import { api } from '../api/client';

const VAPID_PUBLIC = 'BEObg5lvRHVlbeJt1t9rDwepe20tctz6nOftnnNCm3AnW7OaZHGK8JkD28q4xrbDaodE9zexN3zooA1oIdV2lPw';

function urlBase64ToUint8Array(b64: string): Uint8Array {
  const padding = '='.repeat((4 - b64.length % 4) % 4);
  const base64  = (b64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw     = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export async function initPush(): Promise<void> {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

  const perm = await Notification.requestPermission();
  if (perm !== 'granted') return;

  try {
    const reg = await navigator.serviceWorker.ready;
    let sub   = await reg.pushManager.getSubscription();

    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC) as BufferSource,
      });
    }

    await api('/notificaciones?action=subscribe', {
      method: 'POST',
      body: JSON.stringify(sub.toJSON()),
    });
  } catch (e) {
    console.warn('[push] No se pudo suscribir:', e);
  }
}
